export const LoginModalConstant = {
    //modal button values
    GET_OTP: 'GET ONE TIME PASSWORD (OTP)',
    SENDING_OTP: 'SENDING OTP...',
    GET_OTP_V2: 'GET OTP'
}